<template>
  <div class="container-fluid px-0">
    <div class="row py-4" style="max-width: 1080px; margin: 0 auto">
      <div class="col-12 col-lg-5 mb-4">
        <div class="auth-hero">
          <small class="auth-hero__eyebrow">Registro</small>
          <h2 class="auth-hero__title">Crea tu cuenta una sola vez</h2>
          <p class="auth-hero__text">
            Guarda tus datos y accede a tus pedidos desde cualquier comercio
            asociado.
          </p>
          <router-link class="auth-hero__link" :to="getLink('ingresar')">
            ¿Ya tienes cuenta? Ingresar
          </router-link>
        </div>
      </div>

      <div class="col-12 col-lg-7">
        <div class="auth-card">
          <div class="auth-card__header">
            <h3 class="mb-1">Crear cuenta</h3>
            <small class="text-muted">Completa tus datos básicos</small>
          </div>

          <div class="form-row">
            <div class="form-group col-12">
              <label class="font-weight-bold">Nombre</label>
              <input
                type="text"
                v-model.trim="clientName"
                class="form-control auth-input"
                :class="{
                  'is-invalid': clientName && clientName.length < 4,
                  'is-valid': clientName && clientName.length >= 4,
                }"
                placeholder="Tu nombre y apellido"
              />
            </div>

            <div class="form-group col-12">
              <label class="font-weight-bold">Correo</label>
              <input
                type="email"
                autocapitalize="off"
                v-model.trim="email"
                class="form-control auth-input"
                :class="{
                  'is-invalid': email && emailIsValid,
                  'is-valid': email && !emailIsValid,
                }"
                placeholder="tu@correo.cl"
              />
            </div>

            <div class="form-group col-12 col-md-6">
              <label class="font-weight-bold">Contraseña</label>
              <input
                type="password"
                v-model="password"
                class="form-control auth-input"
                :class="{
                  'is-invalid': password && password.length < 6,
                  'is-valid': password && password.length >= 6,
                }"
                placeholder="Mínimo 6 caracteres"
              />
            </div>

            <div class="form-group col-12 col-md-6">
              <label class="font-weight-bold">Repite contraseña</label>
              <input
                type="password"
                v-model="repassword"
                class="form-control auth-input"
                :class="{
                  'is-invalid': repassword && (password.length < 6 || password != repassword),
                  'is-valid': repassword && password.length >= 6 && password == repassword,
                }"
                placeholder="Repite tu contraseña"
              />
            </div>

            <div class="form-group col-12">
              <label class="font-weight-bold">Teléfono</label>
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">+56</span>
                </div>
                <input
                  type="tel"
                  v-model.trim="phone"
                  class="form-control auth-input"
                  :class="{
                    'is-invalid': phone && phone.length != 9,
                    'is-valid': phone && phone.length == 9,
                  }"
                  placeholder="987654321"
                />
              </div>
            </div>
          </div>

          <div class="auth-info">
            Al registrarte aceptas los
            <router-link class="font-weight-bold" :to="getLink('tos')">
              términos y condiciones
            </router-link>
            y podrás usar esta cuenta en comercios asociados a TicketApp.
          </div>

          <div class="pt-3">
            <button
              class="btn btn-primary auth-submit"
              @click="createAccount()"
              :disabled="loading || !formReady"
            >
              {{ loading ? "Creando..." : "Crear cuenta" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      clientName: "",
      email: "",
      password: "",
      repassword: "",
      phone: "",
      loading: false,
    };
  },
  computed: {
    emailIsValid() {
      const email = this.email;
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !re.test(String(email).toLowerCase());
    },
    formReady() {
      return (
        this.clientName.length >= 4 &&
        this.email &&
        !this.emailIsValid &&
        this.password.length >= 6 &&
        this.password === this.repassword &&
        this.phone.length == 9
      );
    },
  },
  methods: {
    createAccount() {
      if (!this.formReady) return;

      this.loading = true;
      this.$http
        .post(`account`, {
          name: this.clientName,
          email: this.email,
          password: this.password,
          phone: this.phone,
        })
        .then(() => {
          this.$bvToast.toast(
            "Cuenta creada. Revisa tu correo y luego ingresa con tus datos.",
            {
              title: "Cuenta creada",
              variant: "success",
              solid: true,
            }
          );
          this.$router.push(this.getLink("ingresar"));
        })
        .catch(({ data }) => {
          const details = data && data.details ? data.details : "";
          this.$bvToast.toast(details || "Ocurrió un error al crear la cuenta", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.auth-hero,
.auth-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.06);
}

.auth-hero {
  height: 100%;
  padding: 1.5rem;
}

.auth-hero__eyebrow {
  display: block;
  margin-bottom: 0.45rem;
  color: #0f766e;
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.auth-hero__title {
  font-weight: 800;
  color: #1e293b;
}

.auth-hero__text {
  color: #64748b;
  max-width: 34rem;
}

.auth-hero__link {
  font-weight: 700;
  color: #2563eb !important;
}

.auth-card {
  padding: 1.5rem;
}

.auth-card__header {
  margin-bottom: 1.25rem;
}

.auth-input {
  min-height: 48px;
  border-radius: 14px;
}

.auth-submit {
  min-width: 170px;
  min-height: 46px;
  border-radius: 14px;
  font-weight: 700;
}

.auth-info {
  padding: 0.95rem 1rem;
  border-radius: 16px;
  background: linear-gradient(180deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid #bfdbfe;
  color: #1e3a8a;
}

.bg-dark .auth-hero,
.bg-dark .auth-card {
  background: rgba(15, 23, 42, 0.82);
  border-color: rgba(71, 85, 105, 0.9);
}

.bg-dark .auth-hero__title,
.bg-dark .auth-card h3,
.bg-dark label {
  color: #f8fafc;
}

.bg-dark .auth-hero__text,
.bg-dark .text-muted {
  color: #cbd5e1 !important;
}

.bg-dark .auth-info {
  background: rgba(30, 41, 59, 0.88);
  border-color: rgba(96, 165, 250, 0.35);
  color: #dbeafe;
}
</style>
